import { Component, OnInit } from '@angular/core';
import { LiquidacionService } from 'src/app/services/liquidacion/liquidacion.service';

/**
 * ATENCIÓN A COMERCIOS (Mario, 14-oct; EJE-02): el contacto general que ve el comercio en su portal («¿con quién
 * hablo?») cuando no tiene ejecutivo asignado. Va en la configuración global (ATENCION_COMERCIOS).
 */
@Component({
  selector: 'app-atencion-comercios',
  templateUrl: './atencion-comercios.component.html',
})
export class AtencionComerciosComponent implements OnInit {
  f: { nombre: string; telefono: string; whatsapp: string; correo: string; horario: string } = { nombre: '', telefono: '', whatsapp: '', correo: '', horario: '' };
  cargando = true;
  guardando = false;
  error = '';
  ok = '';
  constructor(private liq: LiquidacionService) { }
  async ngOnInit(): Promise<void> {
    try { const r = await this.liq.atencionComercios(); if (r?.general) this.f = { ...this.f, ...r.general }; } catch (e: any) { this.error = e?.error?.msg || 'No se pudo leer.'; }
    finally { this.cargando = false; }
  }
  guardar = async (): Promise<void> => {
    this.guardando = true; this.error = ''; this.ok = '';
    try { const r = await this.liq.guardarAtencionComercios(this.f); this.f = { ...this.f, ...(r?.general || {}) }; this.ok = 'Guardado. Los comercios sin ejecutivo ya lo ven en su portal.'; }
    catch (e: any) { this.error = e?.error?.msg || 'No se pudo guardar.'; } finally { this.guardando = false; }
  };
}
